var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { E } from "js-vextensions";
import { BaseComponent, BaseComponentPlus } from "react-vextensions";
import { rootPageDefaultChilds } from "Utils/URL/URLs";
import { Link, Observer } from "vwebapp-framework";
import { store } from "Store";
import { colors } from "../../Utils/UI/GlobalStyles";
// @Observer
export class SubNavBar extends BaseComponent {
    render() {
        const { fullWidth, children } = this.props;
        return (React.createElement("nav", { className: "clickThrough", style: {
                position: "absolute", zIndex: 11, top: 0, width: "100%", textAlign: "center",
            } },
            React.createElement("div", { style: E({ display: "inline-block", background: "rgba(0,0,0,.7)", boxShadow: colors.navBarBoxShadow }, fullWidth ? { width: "100%" } : { borderRadius: "0 0 10px 10px" }) }, children)));
    }
}
let SubNavBarButton = class SubNavBarButton extends BaseComponentPlus({}, {}) {
    render() {
        const { page, subpage, text, actionFuncIfAlreadyActive } = this.props;
        const currentSubpage = store.main[page].subpage || rootPageDefaultChilds[page];
        const active = subpage == currentSubpage;
        let actionFunc;
        if (!active) {
            actionFunc = s => s.main[page].subpage = subpage;
        }
        else if (actionFuncIfAlreadyActive) {
            actionFunc = actionFuncIfAlreadyActive;
        }
        return (React.createElement(Link, { actionFunc: actionFunc, text: text, style: E({
                display: "inline-block", cursor: "pointer", verticalAlign: "middle",
                lineHeight: "30px", color: "#FFF", padding: "0 15px", fontSize: 12, textDecoration: "none", opacity: 0.9,
                ":hover": { color: "rgba(100,255,100,1)" },
            }, active && { color: "rgba(100,255,100,1)" }) }));
    }
};
SubNavBarButton = __decorate([
    Observer
], SubNavBarButton);
export { SubNavBarButton };
